<div class="container-xxl flex-grow-1 container-p-y">
    <div class="container-xxl flex-grow-1 container-p-y">
        <h4 class="fw-bold py-3">
            Dashboard
        </h4>
    </div>
    <div class="container-xxl flex-grow-1 container-p-y">
        <mat-card>
            <!-- <mat-card-header class="mt-3 mb-3">
                <mat-icon class="nav-icon">payment</mat-icon> Automated Service Overview
            </mat-card-header> -->
            <div class="container-xxl flex-grow-1 container-p-y">
                <mat-card-content>
                    <div class="align">
                        <div class="row">
                            <div class="col-md-3">
                                <mat-card class="mt-5 mb-3">
                                    <mat-card-content>
                                        <span class="text">Last<br> Settlement</span>
                                        <img src="../../../assets/images/dollarsign.png">
                                        <div class="account">
                                            ${{this.paymentReceived}}
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            </div>

                            <div class="col-md-3">
                                <mat-card class="mt-5 mb-3">
                                    <mat-card-content>
                                        <span class="text">Settlement<br>  Pending </span>&nbsp;
                                        <img src="../../../assets/images/credit-card.png">
                                        <div class="account">
                                            ${{this.paymentPending}}
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            </div>

                            <div class="col-md-3">
                                <mat-card class="mt-5 mb-3">
                                    <mat-card-content>
                                        <span class="text">Last<br>  Remittance</span>
                                        <img src="../../../assets/images/cash.png">
                                        <div class="account">
                                            ${{this.remittedRecieve}}
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            </div>

                            <div class="col-md-3">
                                <mat-card class="mt-5 mb-3">
                                    <mat-card-content>
                                        <span class="text">Remittance<br>  Pending</span>
                                        <img src="../../../assets/images/dollar.png">
                                        <div class="account">
                                            ${{this.remittedPending}}
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </div>
        </mat-card>
    </div>

    <!-- 5 pay trans -->
    <div class="container-xxl flex-grow-1 container-p-y">
        <mat-card class="mt-3">
            <mat-card-header class="mt-3">
                <span class="material-icons" style="margin-right: 10px;">monetization_on</span>Last 5 Payment
                Transactions
            </mat-card-header>
            <mat-card-content>
                <div class="tab-content mt-4">
                    <div class="card">
                        <table mat-table [dataSource]="paymentTransDataSource" class="mat-elevation-z8">
                            <ng-container matColumnDef="srNo">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="0">S.No</th>
                                <td mat-cell *matCellDef="let item; let j = index">
                                    {{ (j+1)}}</td>
                            </ng-container>

                            <ng-container matColumnDef="orderDate">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="1">Order Date</th>
                                <td mat-cell *matCellDef="let element"> {{element.orderDate | date:
                                    'MM-dd-yyyy'}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="trackingNumber">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="2">Tracking Number
                                </th>
                                <td mat-cell *matCellDef="let element"><a
                                        [routerLink]="['/All/transactionDetails',element.paymentRequestId]"
                                        style="text-decoration: none;"> {{element.trackingNumber |
                                        slice:0:15 }}{{element.trackingNumber?.length > 15 ? '...' : ''}}</a></td>
                            </ng-container>

                            <ng-container matColumnDef="loanNumber">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="3">Loan Id</th>
                                <td mat-cell *matCellDef="let element"> {{element.loanNumber}} </td>
                            </ng-container>

                            <ng-container matColumnDef="cardHolderName">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="4">Card Holder Name
                                </th>
                                <td mat-cell *matCellDef="let element"> {{element.cardHolderName}} </td>
                            </ng-container>

                            <ng-container matColumnDef="settleAmount">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="5">Settle Amount
                                </th>
                                <td mat-cell *matCellDef="let element" style="text-align: right;">
                                    $&#8239;{{element.settleAmount}} </td>
                            </ng-container>

                            <ng-container matColumnDef="settleDate">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="6">Settle Date</th>
                                <td mat-cell *matCellDef="let element"> {{element.settleDate | date:
                                    'MM-dd-yyyy'}} </td>
                            </ng-container>

                            <ng-container matColumnDef="borrowerName">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="7">Borrower Name
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.borrowerName}} </td>
                            </ng-container>

                            <ng-container matColumnDef="vendorName">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="8">Vendor Name</th>
                                <td mat-cell *matCellDef="let element"> {{element.vendorId}} </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumnsPayTrans"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsPayTrans;"></tr>

                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No data matching the filter
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="buttonRow mt-4">
                    <button mat-raised-button class="createButton" routerLink="/All/paymentTransaction"><mat-icon
                            class="nav-icon">visibility</mat-icon>View
                        More</button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <!-- 5 refund -->
    <div class="container-xxl flex-grow-1 container-p-y">
        <mat-card class="mt-3">
            <mat-card-header class="mt-3">
                <span class="material-icons" style="margin-right: 10px;">monetization_on</span>Last 5 Refunds
            </mat-card-header>

            <mat-card-content class="mt-3">
                <div class="tab-content">
                    <div class="card">
                        <table mat-table [dataSource]="refundDataSource" class="mat-elevation-z8">
                            <ng-container matColumnDef="srNo">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="0">S.No</th>
                                <td mat-cell *matCellDef="let item; let j = index">
                                    {{ (j+1) }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="refundReqOn">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="1">Refund Date
                                    </th>
                                <td mat-cell *matCellDef="let element">{{element.refundDate | date:'MM-dd-yyyy'}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="transRefNo">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="2">Transaction
                                    Reference Number</th>
                                <td mat-cell *matCellDef="let element"
                                    (click)="getRefundDetailsById(element.refundRequestId)"
                                    style="color: rgb(69, 116, 243); cursor: pointer; width: 350px;">
                                    {{element.afsTransactionId}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="refundAmount">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="3">Refund Amount
                                </th>
                                <td mat-cell *matCellDef="let element" style="text-align: right;">
                                    $&#8239;{{element.refundAmount}} </td>
                            </ng-container>

                            <ng-container matColumnDef="refundStatus">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="4">Refund Status
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <div *ngIf="element.isRefunded==0 && element.isCancelled==0 && element.refundAttempts==0">{{'Refund Processed'}}</div>
                                    <div *ngIf="element.isRefunded==1">{{'Refunded'}}</div>
                                    <div *ngIf="element.isCancelled==1 && element.isRefunded==0">{{'Refund Cancelled'}}</div>
                                    <div *ngIf="element.refundAttempts>0 && element.isRefunded==0 && element.isCancelled==0">{{'Refund Failed'}}
                                   </div>
                                </td>
                              
                                <!-- <td mat-cell *matCellDef="let element">
                                    <div *ngIf="element.isRefunded==0 && element.isCancelled==0">{{'Refund Processed'}}</div>
                                    <div *ngIf="element.isRefunded==1 && element.isCancelled==0">{{'Refunded'}}</div>
                                    <div *ngIf="element.isRefunded==0 && element.isCancelled==1 && element.refundAttempts==0">{{'Refund Cancelled'}}</div>
                                    <div *ngIf="element.isRefunded==1 && element.isCancelled==1">{{'Refunded'}}</div>
                                    <div *ngIf="element.refundAttempts>0 && !element.isRefunded && element.isCancelled==1">{{'Refund Failed'}}
                                    </div>
                                </td> -->
                            </ng-container>

                            <ng-container matColumnDef="cancel">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="5">Cancel Refund
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <div *ngIf="element.isCancelled==0 && element.isRefunded==0 && element.refundAttempts==0">
                                        <button type="button" class="btn btn-primary mb-3 mt-3"
                                            (click)="cancelRefund(element.refundRequestId)">Cancel</button>
                                    </div>
                                    <!-- <div *ngIf="element.isCancelled==1 && element.isRefunded==1">Can't cancelled</div>
                                    <div *ngIf="element.refundAttempts>0 && element.isRefunded==0 ">{{'Refund Failed'}}</div> -->
                                    <!-- <div *ngIf="element.isRefunded==0 && element.isCancelled==0">{{'Refund Processed'}}</div> -->
                                    <div *ngIf="element.isRefunded==1">{{"Can't Cancelled"}}
                                    </div>
                                    <div
                                        *ngIf="element.isCancelled==1  && element.isRefunded==0">
                                        {{'Refund Cancelled'}}</div>
                                    <!-- <div *ngIf="element.isRefunded==1 && element.isCancelled==1">{{"Can't Cancelled"}}</div> -->
                                    <div *ngIf="element.refundAttempts>0 && element.isRefunded==0 && element.isCancelled==0">{{'Refund Failed'}}</div>
                                </td>
                                <!-- <td mat-cell *matCellDef="let element">
                                    <div *ngIf="!element.isCancelled && !element.isRefunded">
                                        <button type="button" class="btn btn-primary mb-3 mt-3"
                                            (click)="cancelRefund(element.refundRequestId)">Cancel</button>
                                    </div>

                                    <div *ngIf="element.isRefunded==1 && !element.isCancelled">{{"Can't Cancelled"}}</div>
                                    <div *ngIf="!element.refundAttempts && !element.isRefunded && element.isCancelled==1">{{'Refund Cancelled'}}</div>
                                    <div *ngIf="element.isRefunded==1 && element.isCancelled==1">{{"Can't Cancelled"}}</div>
                                    <div *ngIf="element.refundAttempts>0 && !element.isRefunded && element.isCancelled==1">{{'Refund Failed'}}
                                    </div>
                                </td> -->
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumnsRefund"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsRefund;"></tr>

                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="6">No data matching the filter "{{input}}"
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="buttonRow mt-4">
                    <button mat-raised-button class="createButton" [routerLink]="['/All/paymentTransaction']"><mat-icon
                            class="nav-icon">visibility</mat-icon>View
                        More</button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <!-- Last 5 settlements -->
    <div class="container-xxl flex-grow-1 container-p-y">
        <mat-card class="mt-3">
            <mat-card-header class="mt-3">
                <span class="material-icons" style="margin-right: 10px;">monetization_on</span>Last 5 Settlements
            </mat-card-header>

            <mat-card-content class="mt-3">
                <div class="tab-content">
                    <div class="card">
                        <table mat-table [dataSource]="receivedDataSource" class="mat-elevation-z8">
                            <ng-container matColumnDef="srNo">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="0">S.No
                                </th>
                                <td mat-cell *matCellDef="let item; let j = index">
                                    {{ (j+1) }}</td>
                            </ng-container>

                            <ng-container matColumnDef="orderDate">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="1">
                                    Order Date</th>
                                <td mat-cell *matCellDef="let element"> {{element.orderDate | date:
                                    'MM-dd-yyyy'}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="loanNumber">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="2">Loan
                                    Id</th>
                                <td mat-cell *matCellDef="let element"> {{element.loanNumber}} </td>
                            </ng-container>

                            <ng-container matColumnDef="settleDate">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="3">
                                    Settle Date</th>
                                <td mat-cell *matCellDef="let element"> {{element.settleDate | date:
                                    'MM-dd-yyyy'}} </td>
                            </ng-container>
                            <ng-container matColumnDef="lenderName">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="4">
                                    Lender Name</th>
                                <td mat-cell *matCellDef="let element"> {{element.lenderName}} </td>
                            </ng-container>

                            <ng-container matColumnDef="borrower">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="5">
                                    Borrower Name</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.borrower}} </td>
                            </ng-container>

                            <ng-container matColumnDef="vendorName">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="6">
                                    Vendor Name</th>
                                <td mat-cell *matCellDef="let element"> {{element.vendorName}} </td>
                            </ng-container>

                            <ng-container matColumnDef="settleAmt">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="7">
                                    Settle Amount</th>
                                <td mat-cell *matCellDef="let element" style="text-align: right;">
                                    $&#8239;{{element.settleAmt}} </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColPayRec"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColPayRec;"></tr>

                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="8">No data matching the filter "{{input}}"
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <!-- <mat-card-actions>
                    <mat-paginator #received [length]="this.receivedDataSource" [pageSize]="5" [pageSize]="5"
                        [pageSizeOptions]="[5, 10, 25, 100]">
                    </mat-paginator>
                </mat-card-actions> -->
                <div class="buttonRow mt-4">
                    <button mat-raised-button class="createButton" [routerLink]="['/All/paymentTransaction']"><mat-icon
                            class="nav-icon">visibility</mat-icon>View
                        More</button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <!-- settlements pending -->
    <!-- <div class="container-xxl flex-grow-1 container-p-y">
        <mat-card class="mt-3">
            <mat-card-header class="mt-3">
                <span class="material-icons" style="margin-right: 10px;">monetization_on</span>Last 5 Settlements Pending
            </mat-card-header>

            <mat-card-content class="mt-3">
                <div class="tab-content">
                    <div class="card">
                        <table mat-table [dataSource]="pendingPayDataSource" class="mat-elevation-z8">
                            <ng-container matColumnDef="srNo">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="0">S.No
                                </th>
                                <td mat-cell *matCellDef="let item; let j = index">
                                    {{ (j+1) }}</td>
                            </ng-container>

                            <ng-container matColumnDef="orderDate">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="1">
                                    Order Date</th>
                                <td mat-cell *matCellDef="let element"> {{element.orderDate | date:
                                    'dd/MM/yyyy'}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="loanNumber">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="2">Loan
                                    Id</th>
                                <td mat-cell *matCellDef="let element"> {{element.loanNumber}} </td>
                            </ng-container>

                            <ng-container matColumnDef="settleDate">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="3">
                                    Settle Date</th>
                                <td mat-cell *matCellDef="let element"> {{element.settleDate | date:
                                    'dd/MM/yyyy'}} </td>
                            </ng-container>
                            <ng-container matColumnDef="lenderName">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="4">
                                    Lender Name</th>
                                <td mat-cell *matCellDef="let element"> {{element.lenderName}} </td>
                            </ng-container>

                            <ng-container matColumnDef="borrower">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="5">
                                    Borrower Name</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.borrower}} </td>
                            </ng-container>

                            <ng-container matColumnDef="vendorName">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="6">
                                    Vendor Name</th>
                                <td mat-cell *matCellDef="let element"> {{element.vendorName}} </td>
                            </ng-container>

                            <ng-container matColumnDef="settleAmt">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="7">
                                    Settle Amount</th>
                                <td mat-cell *matCellDef="let element" style="text-align: right;">
                                    $&#8239;{{element.settleAmt}} </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayPendingPayments"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayPendingPayments;"></tr>

                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No data matching the filter "{{input}}"
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <mat-card-actions>
                    <mat-paginator #pendingpay [length]="this.pendingPayDataSource" [pageSize]="5" [pageSize]="5"
                        [pageSizeOptions]="[5, 10, 25, 100]">
                    </mat-paginator>
                </mat-card-actions>
                <div class="buttonRow mt-4">
                    <button mat-raised-button class="createButton" [routerLink]="['/All/paymentTransaction']"><mat-icon
                            class="nav-icon">visibility</mat-icon>View
                        More</button>
                </div>
            </mat-card-content>
        </mat-card>
    </div> -->

    <!-- last remitted pay -->
    <div class="container-xxl flex-grow-1 container-p-y">
        <mat-card class="mt-3">
            <mat-card-header class="mt-3">
                <span class="material-icons" style="margin-right: 10px;">monetization_on</span> Last 5 Remittances
            </mat-card-header>

            <mat-card-content class="mt-3">
                <div class="tab-content">
                    <div class="card">
                        <table mat-table [dataSource]="remittedDataSource" class="mat-elevation-z8">
                            <ng-container matColumnDef="srNo">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="0">S.No
                                </th>
                                <td mat-cell *matCellDef="let item; let j = index">
                                    {{ (j+1) }}</td>
                            </ng-container>

                            <ng-container matColumnDef="loanNumber">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="1">Loan
                                    Id</th>
                                <td mat-cell *matCellDef="let element"> {{element.loanNumber}} </td>
                            </ng-container>

                            <ng-container matColumnDef="borrower">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="2">
                                    Borrower Name</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.borrower}} </td>
                            </ng-container>

                            <ng-container matColumnDef="propertyAddress">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="3">
                                    Property Address</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.propertyAddress}} </td>
                            </ng-container>

                            <ng-container matColumnDef="lenderName">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="4">Lender Name</th>
                                <td mat-cell *matCellDef="let element"> {{element.lenderName}} </td>
                            </ng-container>

                            <ng-container matColumnDef="orderDate">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="5">
                                    Order Date</th>
                                <td mat-cell *matCellDef="let element"> {{element.orderDate | date:
                                    'MM-dd-yyyy'}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="remitDate">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="6">
                                    Remit Date</th>
                                <td mat-cell *matCellDef="let element"> {{element.remitDate | date:
                                    'MM-dd-yyyy'}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="settleDate">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="7">
                                    Settle Date</th>
                                <td mat-cell *matCellDef="let element"> {{element.settleDate | date:
                                    'MM-dd-yyyy'}} </td>
                            </ng-container>

                            <ng-container matColumnDef="refundAmount">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="8">
                                    Refund Amount</th>
                                <td mat-cell *matCellDef="let element" style="text-align: right;">
                                    $&#8239;{{element.refundAmount}} </td>
                            </ng-container>

                            <ng-container matColumnDef="settleAmt">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="9">
                                    Settle Amount</th>
                                <td mat-cell *matCellDef="let element" style="text-align: right;">
                                    $&#8239;{{element.settleAmt}} </td>
                            </ng-container>

                            <ng-container matColumnDef="remitAmount">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="10">
                                    Remit Amount </th>
                                <td mat-cell *matCellDef="let element" style="text-align: right;">
                                    $&#8239;{{element.remitAmount}} </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayColRemitted"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayColRemitted;"></tr>

                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="11">No data matching the filter "{{input}}"
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <!-- <mat-card-actions>
                    <mat-paginator #remit [length]="this.remittedDataSource" [pageSize]="5" [pageSize]="5"
                        [pageSizeOptions]="[5, 10, 25, 100]">
                    </mat-paginator>
                </mat-card-actions> -->
                <div class="buttonRow mt-4">
                    <button mat-raised-button class="createButton" [routerLink]="['/All/paymentTransaction']"><mat-icon
                            class="nav-icon">visibility</mat-icon>View
                        More</button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

     <!-- pending remittance  -->
     <!-- <div class="container-xxl flex-grow-1 container-p-y">
        <mat-card class="mt-3">
            <mat-card-header class="mt-3">
                <span class="material-icons" style="margin-right: 10px;">monetization_on</span>Last 5 Remittance Pending
            </mat-card-header>

            <mat-card-content class="mt-3">
                <div class="tab-content">
                    <div class="card">
                        <table mat-table [dataSource]="pendingRemittedDataSource" class="mat-elevation-z8" >
                            <ng-container matColumnDef="srNo" >
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="0" >S.No
                                </th>
                                <td mat-cell *matCellDef="let item; let j = index" >
                                    {{ (j+1) }}</td>
                            </ng-container>

                            <ng-container matColumnDef="loanNumber">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="1">Loan
                                    Id</th>
                                <td mat-cell *matCellDef="let element"> {{element.loanNumber}} </td>
                            </ng-container>

                            <ng-container matColumnDef="borrower">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="2">
                                    Borrower Name</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.borrower}} </td>
                            </ng-container>

                            <ng-container matColumnDef="propertyAddress">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="3">
                                    Property Address</th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.propertyAddress}} </td>
                            </ng-container>

                            <ng-container matColumnDef="lenderName">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="4">Lender Name</th>
                                <td mat-cell *matCellDef="let element"> {{element.lenderName}} </td>
                            </ng-container>

                            <ng-container matColumnDef="orderDate">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="5">
                                    Order Date</th>
                                <td mat-cell *matCellDef="let element"> {{element.orderDate | date:
                                    'dd/MM/yyyy'}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="remitDate">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="6">
                                    Remit Date</th>
                                <td mat-cell *matCellDef="let element"> {{element.remitDate | date:
                                    'dd/MM/yyyy'}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="settleDate">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="7">
                                    Settle Date</th>
                                <td mat-cell *matCellDef="let element"> {{element.settleDate | date:
                                    'dd/MM/yyyy'}} </td>
                            </ng-container>

                            <ng-container matColumnDef="refundAmount">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="8">
                                    Refund Amount</th>
                                <td mat-cell *matCellDef="let element" style="text-align: right;">
                                    $&#8239;{{element.refundAmount}} </td>
                            </ng-container>

                            <ng-container matColumnDef="settleAmt">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="9">
                                    Settle Amount</th>
                                <td mat-cell *matCellDef="let element" style="text-align: right;">
                                    $&#8239;{{element.settleAmt}} </td>
                            </ng-container>

                            <ng-container matColumnDef="remitAmount">
                                <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" [index]="10">
                                    Remit Amount </th>
                                <td mat-cell *matCellDef="let element" style="text-align: right;">
                                    $&#8239;{{element.remitAmount}} </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayColPendingRemittance"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayColPendingRemittance;"></tr>

                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No data matching the filter "{{input}}"
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <mat-card-actions>
                    <mat-paginator #pendingRemit [length]="this.pendingRemittedDataSource" [pageSize]="5" [pageSize]="5"
                        [pageSizeOptions]="[5, 10, 25, 100]">
                    </mat-paginator>
                </mat-card-actions>
                <div class="buttonRow mt-4">
                    <button mat-raised-button class="createButton" [routerLink]="['/All/paymentTransaction']"><mat-icon
                            class="nav-icon">visibility</mat-icon>View
                        More</button>
                </div>
            </mat-card-content>
        </mat-card>
    </div> -->
</div>

<div id="loadingspinner" *ngIf="isLoading">
    <div class="spinner">
        <img src="../../../assets/images/spinner.gif" alt="Loading. Please wait.">
    </div>
</div>